import { render, staticRenderFns } from "./AssignmentsNeedsFurtherReview.vue?vue&type=template&id=1c54be66&scoped=true&"
import script from "./AssignmentsNeedsFurtherReview.vue?vue&type=script&lang=js&"
export * from "./AssignmentsNeedsFurtherReview.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentsNeedsFurtherReview.vue?vue&type=style&index=0&id=1c54be66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c54be66",
  null
  
)

export default component.exports